/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Join__InstructionsInputs */

const en_header_join__instructions = /** @type {(inputs: Header_Join__InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In some languages 'join in' might be more appropriate if the translation doesn't consist of two words.`)
};

/**
* | output |
* | --- |
* | "In some languages 'join in' might be more appropriate if the translation doesn't consist of two words." |
*
* @param {Header_Join__InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_join__instructions = /** @type {((inputs?: Header_Join__InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Join__InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_join__instructions(inputs)
});